import apiService from '@/services/apiService';

const actions = {
  getBannerMicroisites({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('microsite-banner/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getBannerMicroisite({ commit }, payload) {
    apiService.get(`microsite-banner/${payload}`)
      .then((response) => {
        commit('getBannerMicroisite', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getArticle({ commit }) {
    apiService.get('article?is_cms=true&status=publish,highlight')
      .then((response) => {
        commit('getArticle', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  postBannerMicroisites({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('microsite-banner', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putBannerMicroisites({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`microsite-banner/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  orderBannerMicroisites({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`microsite-banner/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delBannerMicroisites({ commit }, payload) {
    apiService.delete(`microsite-banner/${payload}`)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
